import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatDatepickerInputEvent,
  MatPaginator,
  PageEvent,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { ActivatedRoute, Router } from "@angular/router";
import { GameReportByUser } from "src/_models";
import { ConvertUpochToDate } from "src/_helpers/utils";
import { Location } from "@angular/common";
import * as moment from "moment";

@Component({
  selector: "gm-report-user-level",
  templateUrl: "./gr-user-level.component.html",
  styleUrls: ["../game-report.component.scss"],
})
export class GmRepUserLevelComponent implements OnInit {
  datalistDisplayedColumns: string[] = [
    "UserName",
    "TotalBets",
    "TotalAmount",
    "TotalCommission",
    "TotalCancel",
    "TotalLost",
    "TotalWon",
    "ToTalCashedOut",
    "CashedOutAmount",
    "TotalProfit",
  ];
  providers: any = [];
  datalist = new MatTableDataSource<GameReportByUser>();
  selectedUser: { userId: string; userName: string };
  selectedUserName = "";
  filterUsers = [];
  users = [];

  providerId = "";
  userID: string = "";
  operatorId = "";
  sportId: string = null;
  sportName = null;
  eventId = null;
  marketId = null;
  marketName = null;
  eventName = null;
  competitionId = null;
  userName: any;
  origin = [];
  prTitle = "";
  category = "";
  subProvider = "";
  selected: any = { startDate: 0, endDate: 0 };
  competitionName = "";
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  length: any = 0;
  sort = 1;
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.providerId = this.activatedRoute.snapshot.params.providerId;
    this.sportId = this.activatedRoute.snapshot.params.sportId;
    this.competitionId = this.activatedRoute.snapshot.params.competitionId;
    this.eventId = this.activatedRoute.snapshot.params.eventId;
    this.marketId = this.activatedRoute.snapshot.params.marketId;

    this.activatedRoute.queryParams.subscribe((params) => {
      this.providerId = params.providerId;
      this.sportName = params.sportsName;
      this.eventName = params.eventName;
      this.userID = params.userId;
      this.origin = params.origin;
      this.category = params.category;
      this.subProvider = params["subProvider"];
      this.userName = params.userName;
      this.marketName = params.marketName;
      this.competitionName = params.competitionName;
      (this.sportName = params.sportName),
        (this.operatorId = params.operatorId);
      this.selected = {
        startDate:
          params.startTime !== "0"
            ? new Date(params.startTime * 1000)
            : new Date(),
        endDate:
          params.endTime !== "0" ? new Date(params.endTime * 1000) : new Date(),
      };
      if (this.providerId && this.sportId) {
        this.getReportData();
      }
      let lowerCaseOrigins = this.origin.map(item => item.toLowerCase());
      this.prTitle = lowerCaseOrigins.length > 0 ? lowerCaseOrigins.join(', ') : "";
    });

    console.log(this.marketName);
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  goBackToEventLevel = () => {
    this.router.navigate(
      [
        `reports/game_report/${this.providerId}/${this.sportId}/${this.competitionId}/${this.eventId}`,
      ],
      {
        queryParams: {
          providerId: this.providerId,
          sportId: this.sportId,
          eventName: this.eventName,
          sportName: this.sportName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          competitionName: this.competitionName,
          operatorId: this.operatorId,
          userId: this.userID ? this.userID : "",
          userName: this.userName ? this.userName : "",
          startTime:
            this.selected.startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            this.selected.endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };

  handleSorting() {
    if (this.sort === 1) {
      this.sort = -1
    } else {
      this.sort = 1;
    }
    this.getReportData();
  }

  goBackToCompetitionLevel = () => {
    this.router.navigate(
      [
        `reports/game_report/${this.providerId}/${this.sportId}/${this.competitionId}`,
      ],
      {
        queryParams: {
          operatorId: this.operatorId,
          providerId: this.providerId,
          sportId: this.sportId,
          sportName: this.sportName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          competitionName: this.competitionName,
          competitionId: this.competitionId,
          userId: this.userID ? this.userID : "",
          userName: this.userName ? this.userName : "",

          startTime:
            this.selected.startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            this.selected.endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };

  goBackToSportsLevel = () => {
    this.router.navigate(
      [`reports/game_report/${this.providerId}/${this.sportId}`],
      {
        queryParams: {
          providerId: this.providerId,
          userId: this.userID ? this.userID : "",
          sportId: this.sportId,
          sportName: this.sportName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          userName: this.userName ? this.userName : "",
          operatorId: this.operatorId,
          startTime:
            this.selected.startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            this.selected.endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };

  goBackToProviderLevel = () => {
    this.router.navigate([`reports/game_report/${this.providerId}`], {
      queryParams: {
        providerId: this.providerId,
        userId: this.userID ? this.userID : "",
        userName: this.userName ? this.userName : "",
        operatorId: this.operatorId,
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        startTime:
          this.selected.startDate !== null
            ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
      },
    });
  };

  goBackGameLevel = () => {
    this.router.navigate([`reports/game_report/`]);
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getReportData();
  }

  getReportData = () => {
    try {
      let startDate, endDate;
      this.activatedRoute.queryParams.subscribe((params) => {
        (startDate = params.startTime), (endDate = params.endTime);
      });
      let filters = {
        userId: this.userID ? this.userID : null,
        providerId: this.providerId,
        sportId: this.sportId,
        sportName: this.sportName,
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        eventId: this.eventId,
        marketId: this.marketId,
        operatorId: this.operatorId,
        competitionId: this.competitionId,
        sort : this.sort,
        startTime:
          startDate === "0"
            ? 0
            : parseInt(
                (new Date(this.selected.startDate).getTime() / 1000).toFixed(0)
              ),
        endTime:
          endDate === "0"
            ? 0
            : parseInt(
                (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
              ),
        pageSize: this.orgPageSize,
        page: this.page,
      };

      this.appService.getGMReportByUserLevel(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.datalist = new MatTableDataSource<GameReportByUser>(
            res.userGamesReports
          );
          if (this.page == 1) {
            this.length = res.totalRecords;
          } else {
            this.paginator.length = this.length;
          }
        }
      });
    } catch (err) {}
  };

  formatDate(date) {
    return ConvertUpochToDate(date);
  }

  goToMarketLevel = (row: GameReportByUser) => {
    let startDate, endDate;
    this.activatedRoute.queryParams.subscribe((params) => {
      (startDate = params.startTime), (endDate = params.endTime);
    });
    this.router.navigate(
      [
        `reports/game_report/${this.providerId}/${this.sportId}/${this.competitionId}/${this.eventId}/${this.marketId}/${row.userId}`,
      ],
      {
        queryParams: {
          providerId: this.providerId,
          sportName: this.sportName,
          eventName: this.eventName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          marketName: this.marketName,
          userId: this.userID ? this.userID : "",
          competitionName: this.competitionName,
          userName: this.userName ? this.userName : "",
          operatorId: this.operatorId,
          startTime:
            startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };
}
